<template>
  <!-- <Header></Header> -->
  <nav>
    <div class="navbar">
      <div class="container-fluid">
        <a class="navbar-brand">
          <img class="img-fluid" width="200px" src="../assets/logo.svg" alt=""  @click="goEvents">
        </a>
        <div class="d-flex">
          <a class="mt-2 me-1" role="button" @click="doAccount">
            <svg class="account-svg bi bi-person-fill" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                 viewBox="0 0 16 16">
              <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
            </svg>
            My Account
          </a>
        </div>
      </div>
    </div>
  </nav>
  <div class="main-height player-style">
    <div className="col-md-offset-3 col-sm-7 col-sm-offset-3" style='margin:0px auto;'>
      <div className="account-heading"><strong>Playing now:</strong> {{ eventTitle }}</div>
      <video-player
          id="VideoPlayer"
          :class="[
          'vjs-big-play-centered',
        ]"
          :style="{ backgroundColor: 'black'}"
          :src=configVideoJS.src
          :autoplay=configVideoJS.autoplay
          :volume=configVideoJS.volume
          :controls=configVideoJS.controls
          :muted=configVideoJS.muted
          :width=configVideoJS.width
          :height=configVideoJS.height
          :fluid=configVideoJS.fluid
          :loop=configVideoJS.loop
          :crossorigin=configVideoJS.crossorigin
          :disablePictureInPicture=configVideoJS.disablePictureInPicture
          :preferFullWindow=configVideoJS.preferFullWindow
          :playsinline=configVideoJS.playsinline
          :plugins=configVideoJS.plugins
          :html5=configVideoJS.html5
          :options=configVideoJS.options
          @ready="handlePlayerReady"
          @mounted="handleMounted"
          @unmounted="handleUnmounted"
          @error="handleError"
          @emptied="handleEmptied"
          @abort="handleAbort"
          @suspend="handleSuspend"
          @stalled="handleStalled"
      >
      </video-player>
      <div v-if="alternativeChannelAvailable" class="text-center">
        <br>
        <p class="change-source-text">Having problems with the stream?</p>
        <button @click="changeSource" class="btn change-source-btn">Alternative source</button>
      </div>
    </div>
  </div>
  <div class=""><Footer></Footer></div>
</template>

<script >
import {defineComponent, shallowReactive} from 'vue'
import Footer from "@/components/Footer.vue";
import VueSimpleAlert from 'vue3-simple-alert';
import UsersService from "@/services/users-service";
import AuthService from "@/services/auth-service";
import SessionService from "@/services/session-service"
import UserAgentParser from '@/utils/user-agent-parser'
import { VideoPlayer } from '@videojs-player/vue'
import 'videojs-contrib-quality-levels'
import videojsqualityselector from 'videojs-hls-quality-selector'
import 'video.js/dist/video-js.css'
import videojslandscapefullscreen from 'videojs-landscape-fullscreen'
import { event } from "vue-gtag";
import LeagueService from "@/services/league-service";

export default defineComponent({
  name: 'Player',
  components: {
    // Header,
    VideoPlayer,
    Footer
  },
  setup() {
    const playerPage = () => {
      event('player', { method: 'Google' })
    }
    return {
      playerPage
    }
  },

  data() {
    return {
      userProfile: null,
      userPlan: null,
      interval: null,
      streamUrl: "",
      baseStreamUrl: "",
      channelName: "",
      handleErrorOnce: false,
      player: null,
      eventTitle: "",
      configVideoJS: null,
      userAgent: "",
      deviceType: null,
      deviceOs: null,
      appVersion: "",
//      videoStarted: true,
      channel: null,
      dynamicData: [],
      alternativeChannelAvailable: false,
      isChangedDynamic: false
    }
  },
  methods: {
    changeSource() {
       let currentValue = localStorage.getItem('changeSrc');
        localStorage.setItem('changeSrc', currentValue === "true" ? "false" : "true");
        this.leavePage(true);
    },
    channelDisconnects: function() {
      //this.videoStarted = false;
      VueSimpleAlert.alert("Channel is not available. Try again later.", "Player error")
      this.$router.push('/events')
    },
    handleMounted: function (payload) {
      //console.log('----handleMounted', payload)
      this.player = payload.player
    },
    goEvents () {
      this.$router.push('/events')
    },
    handleUnmounted: function () {
      //console.log('---handleUnmounted')
    },
    handlePlayerReady: function (event) {
      //console.log('---handlePlayerReady', event)
      if (this.userProfile.videoQuality === undefined) {
        this.player.hlsQualitySelector = videojsqualityselector;
        this.player.hlsQualitySelector({
          displayCurrentQuality: true,
          placementIndex: 2
        })
      }
      this.player.landscapeFullscreen = videojslandscapefullscreen;
      this.player.landscapeFullscreen({
        fullscreen: {
          enterOnRotate: true,
          exitOnRotate: true,
          alwaysInLandscapeMode: true,
          iOS: false
        }
      })

       this.player?.ready(() => {
         const tech = this.player.tech();
         if (tech && tech.vhs && tech.vhs.xhr) {
           tech.vhs.xhr.beforeRequest = (options) => {
             //check if playlist request
             const newSkValue = localStorage.getItem('sk');
             if (newSkValue !== null) {
               options.uri = options.uri.replace(/&sk=[^&]*$/, `&sk=${newSkValue}`);
             }
             return options;
           };
         }
       });
      // this.player.on('playing', () => {
      //   console.log("Video is playing!");
      //   this.videoStarted = true;
      // })
    },
    handleError: function (event) {
      //console.log('---handleError', event)
      this.channelDisconnects()
    },
    handleEmptied: function (event) {
      //console.log('---handleEmptied', event)
    },
    handleSuspend: function (event) {
      //console.log('---suspend', event)
    },
    handleAbort: function (event) {
      //console.log('---abort', event)
    },
    handleStalled: function (event) {
      //console.log('---stalled', event)
    },
    getUserLatest: function () {
      UsersService.getUserLatest().then((newUserLatest) => {
        if (newUserLatest) {
          this.compareUserLatest(newUserLatest)
        }
      })
    },
    compareUserLatest: function (newUserLatest) {
      if (localStorage.getItem('userLatest') && localStorage.getItem('userLatest') !== JSON.stringify(newUserLatest)) {
        const oldUserLatest = JSON.parse(localStorage.getItem('userLatest'))
        // compare user latest
        if (oldUserLatest.loginId !== newUserLatest.loginId) {
          AuthService.signOut().then(() => {
            localStorage.setItem('sessionExpired', "true")
            this.$router.push('/signin')
          })
        }
        if (oldUserLatest.userProfile !== newUserLatest.userProfile
            || oldUserLatest.userPlans !== newUserLatest.userPlans) {
          // check if you already made a request
          if (this.isChangedDynamic) {
            this.isChangedDynamic = false;
          } else {
            // update dynamics because region and quality are stored inside profile
            UsersService.getDynamicData().then((data) => {
              this.dynamicData = data
            })
          }
          // update user profile
          UsersService.getUserProfile().then(() => {
            if (localStorage.getItem('userProfile')) this.userProfile = JSON.parse(localStorage.getItem('userProfile'))
            if (localStorage.getItem('userPlan')) this.userPlan = JSON.parse(localStorage.getItem('userPlan'))
            if (this.userPlan.trial && (this.userProfile.trialOverallTime <= 0 || this.userProfile.trialTodayTime <= 0)) {
              this.$router.push('/plans')
            }
            if (this.userProfile) this.planEndDate = new Date(this.userProfile.planEndDate).toLocaleDateString()
          })
        }
        if (oldUserLatest.payments !== newUserLatest.payments) {
          // update user payments
        }
        if (oldUserLatest.statics !== newUserLatest.statics) {
          UsersService.getUserStaticData()
        }
        if (oldUserLatest.channels !== newUserLatest.channels) {
          // update leagues
          LeagueService.getLeagueList().then(() => {
            if (localStorage.getItem('leagueList')) {
              this.leaguesList = JSON.parse(localStorage.getItem('leagueList'))
              this.eventsList = []
              this.leaguesList.forEach(league => {
                // Check if the leagueId matches
                if (league.application === "procricket") {
                  league.events.forEach(event => {
                    this.eventsList.push(event);
                    if (event.eventId === this.channel.eventId) {
                      if (event.channels[0] && event.channels[0].status && event.channels[0].active && event.channels[1] && event.channels[1].status && event.channels[1].active) {
                        const alternative = event.channels.find(ch => ch.channelId !== this.channel.channelId);
                        localStorage.setItem('alternativeChannel',  JSON.stringify(alternative))
                        this.alternativeChannelAvailable = true
                      } else {
                        localStorage.removeItem('alternativeChannel')
                        localStorage.removeItem('changeSrc')
                        this.alternativeChannelAvailable = false
                      }
                    }
                  });
                  if (this.eventsList.length > 0) {
                    this.mainEvent = this.eventsList.shift();
                  }
                }
              });
            }
          })
        }
      }
      this.error = newUserLatest.errorText
      localStorage.setItem('userLatest', JSON.stringify(newUserLatest))
    },
    doAccount() {
      this.$router.push('/account')
    },
    setupPlayer() {
      if (this.channel.edgePort === "" || this.channel.edgePort === undefined) {
        this.baseStreamUrl = "https://" + this.dynamicData.edgeAddress + "/"
      } else {
        this.baseStreamUrl = "https://" + this.dynamicData.edgeAddress + ":" + this.channel.edgePort + "/"
      }
      this.streamUrl = this.channel.appName + "/" + this.checkUndefined(this.channel.hlsPrefix) + this.channel.channelName
          + this.checkUndefined(this.channel.hlsSufix)
          + this.checkUndefined(this.dynamicData.videoQuality)
          + "/playlist.m3u8?id=" + this.channel.channelId + "&pk=" + this.dynamicData.pk + "&userId="
          + this.userProfile.userId + "&vidictid=" + this.dynamicData.vidictId
      const skValue = localStorage.getItem('sk');
      if (skValue !== null) {
        this.streamUrl += "&sk=" + skValue
      }
      this.streamUrl = this.baseStreamUrl + this.streamUrl;
      this.configVideoJS = shallowReactive({
        src: this.streamUrl,
        autoplay: true,
        width: 800,
        height: 600,
        volume: 0.8,
        controls: true,
        fluid: true,
        muted: false,
        loop: false,
        crossorigin: 'anonymous',
        responsive: true,
        preferFullWindow: true,
        playsinline: false,
        disablePictureInPicture: true,
        plugins: {
        },
        html5: {
          vhs: {
            maxPlaylistRetries: 3,
            enableLowInitialPlaylist: false,
            limitRenditionByPlayerDimensions: false,
            overrideNative: true,
            useNetworkInformationApi: true
          },
          nativeAudioTracks: false,
          nativeVideoTracks: false
        },
        options: {controlBar: { children: ['playToggle','liveDisplay', 'volumePanel', 'fullscreenToggle']} }
      })
    },
    leavePage: function (reload) {
      try {
        this.player.dispose();
        clearInterval(this.interval);
        if (this.dynamicData && this.dynamicData.vidictId) {
          const session = UserAgentParser.createSession(this.dynamicData.vidictId, this.deviceOs, this.deviceType, this.appVersion, this.userAgent);
          SessionService.updateAndDisconnectSession(session).finally(() => {
            if (reload) location.reload();
          });
        }
      } catch (error) {
        console.error("Error during source change:", error);
        this.$router.push('/events')
      }
    },
    checkUndefined (inputString) {
      if (typeof inputString === 'undefined' || inputString === '' || inputString === null) {
        return '';
      } else {
        return inputString;
      }
    }
  },
  mounted() {
    this.getUserLatest();
    this.interval = setInterval(function () {
      this.getUserLatest();
    }.bind(this), 30000);
  },
  beforeMount() {
      clearInterval(this.interval);
      if (localStorage.getItem('userProfile')) this.userProfile = JSON.parse(localStorage.getItem('userProfile'))
      if (localStorage.getItem('userPlan')) this.userPlan = JSON.parse(localStorage.getItem('userPlan'))
      if (localStorage.getItem('eventTitle')) this.eventTitle = localStorage.getItem('eventTitle')
      if (localStorage.getItem('channel')) this.channel = JSON.parse(localStorage.getItem('channel'))
      if (localStorage.getItem('alternativeChannel')) this.alternativeChannelAvailable = true
      if (JSON.parse(localStorage.getItem('changeSrc'))) {
        if (localStorage.getItem('alternativeChannel')) this.channel = JSON.parse(localStorage.getItem('alternativeChannel'))
      }
      if (localStorage.getItem('dynamicData')) {
        this.dynamicData = JSON.parse(localStorage.getItem('dynamicData'))
        this.setupPlayer();
      } else {
        this.isChangedDynamic = true;
        UsersService.getDynamicData().then((data) => {
          this.dynamicData = data;
          this.setupPlayer();
        });
      }
      if (localStorage.getItem('coupon')) {
        localStorage.setItem('coupon', null)
      }
      this.userAgent = navigator.userAgent;
      this.deviceType = UserAgentParser.extractDeviceType(this.userAgent);
      this.deviceOs = UserAgentParser.extractDeviceOs(this.userAgent);
      this.appVersion = UserAgentParser.getAppVersion(this.userAgent, this.deviceType);
  },

  beforeUnmount() {
    this.leavePage()
  },

  computed: {
  }
})
</script>

<style scoped>
@import '../assets/style.css';

.player-style {
  margin-top: 3%;
  margin-bottom: 3%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}


</style>
